import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import BAATemplate from "./views/BAATemplate.vue";
import BAA_NDATemplate from "./views/BAA_NDATemplate.vue";
import NDATemplate from "./views/NDATemplate.vue";
import PostIRTemplate from "./views/PostIRTemplate.vue";
import MDRTemplate from "./views/MDRTemplate.vue";
import MDRS1MTMTemplate from "./views/MDRS1MTMTemplate.vue";
import ChooseDocument from "./views/ChooseDocument.vue";
import SelectTemplate from "./views/SelectTemplate.vue";
import Placeholders from "./views/FillPlaceholders.vue";
import FillScope from "./views/FillScope.vue";
import ReviewContent from "./views/ReviewContent.vue";
import GenerateSoW from "./views/GenerateSoW.vue";
import GenerateNDA from "./views/GenerateNDA.vue";
import GenerateMDRS1MtM from "./views/GenerateNDA.vue";
import GenerateMDR from "./views/GenerateMDR.vue";
import GeneratePostIR from "./views/GeneratePostIR.vue";
import GenerateBAA from "./views/GenerateBAA.vue";
import GenerateBAANDA from "./views/GenerateBAA_NDA.vue";
import ViewSoWs from "./views/ViewSoWs.vue";
import ViewBAAs from "./views/ViewBAAs.vue";
import ViewNDAs from "./views/ViewNDAs.vue";
import ViewBAA_NDA from "./views/ViewBAA_NDA.vue";
import ViewAmendments from "./views/ViewAmendments.vue";
import SearchClient from "./views/SearchClient.vue";
import store from "./store";
import security from "./utils/msalUtil";

Vue.use(Router);

async function checkAuth(to, from, next) {
  if (!store.getters.isAuthenticated) {
    NProgress.start();
    var tokenResponse = await security.acquireTokenSilent();
    if (tokenResponse === null) {
      window.location.href = "/";
    } else {
      store.commit("login", tokenResponse.token);
      store.commit("user", {
        user: tokenResponse.account
      });
      NProgress.done();
      if (
        !(
          window.location.href.toLowerCase().indexOf("choose") !== -1 ||
          window.location.href.toLowerCase().indexOf("document") !== -1
        )
      ) {
        window.location.href = "/choose-document";
      } else {
        next();
      }
    }
  }
  else {
    next();
  }
}
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/baa-template",
      name: "baatemplate",
      component: BAATemplate,
      beforeEnter: checkAuth
    },
    {
      path: "/nda-template",
      name: "ndatemplate",
      component: NDATemplate,
      beforeEnter: checkAuth
    },
    {
      path: "/baa-nda-template",
      name: "baa-ndatemplate",
      component: BAA_NDATemplate,
      beforeEnter: checkAuth
    },
    {
      path: "/choose-document",
      name: "choosedocument",
      component: ChooseDocument,
      beforeEnter: checkAuth
    },
    {
      path: "/select-template", ///:lawfirm?",
      name: "select-template",
      component: SelectTemplate,
      beforeEnter: checkAuth
    },
    {
      path: "/fill-placeholders",
      name: "fill-placeholders",
      component: Placeholders,
      beforeEnter: checkAuth
    },
    {
      path: "/fill-scope",
      name: "fill-scope",
      component: FillScope,
      beforeEnter: checkAuth
    },
    {
      path: "/review-content",
      name: "review-content",
      component: ReviewContent,
      beforeEnter: checkAuth
    },
    {
      path: "/generate-sow",
      name: "generate-sow",
      component: GenerateSoW,
      beforeEnter: checkAuth
    },
    {
      path: "/generate-baa",
      name: "generate-baa",
      component: GenerateBAA,
      beforeEnter: checkAuth
    },
    {
      path: "/generate-nda",
      name: "generate-nda",
      component: GenerateNDA,
      beforeEnter: checkAuth
    },
    {
      path: "/generate-baa_nda",
      name: "generate-baa_nda",
      component: GenerateBAANDA,
      beforeEnter: checkAuth
    },
    {
      path: "/sows", //:lawfirm?",
      name: "sows",
      component: ViewSoWs,
      beforeEnter: checkAuth
    },
    // {
    //   path: "/baas",
    //   name: "baas",
    //   component: ViewBAAs,
    //   beforeEnter: checkAuth
    // },
    // {
    //   path: "/ndas",
    //   name: "ndas",
    //   component: ViewNDAs,
    //   beforeEnter: checkAuth
    // },
    {
      path: "/amendments/:slug",
      name: "amendments",
      component: ViewAmendments,
      beforeEnter: checkAuth
    },
    {
      path: "/search-client",
      name: "searchclient",
      component: SearchClient,
      beforeEnter: checkAuth
    },
    {
      path: "/baandas",
      name: "baandas",
      component: ViewBAA_NDA,
      beforeEnter: checkAuth
    },
    {
      path: "/postir-template",
      name: "postir-template",
      component: PostIRTemplate,
      beforeEnter: checkAuth
    },
    {
      path: "/mdr-template",
      name: "mdr-template",
      component: MDRTemplate,
      beforeEnter: checkAuth
    },
    {
      path: "/mdrs1-mtm-template",
      name: "mdrs1-mtm-template",
      component: MDRS1MTMTemplate,
      beforeEnter: checkAuth
    }, 
    {
      path: "/generate-postir",
      name: "generate-postir",
      component: GeneratePostIR,
      beforeEnter: checkAuth
    }, 
    {
      path: "/generate-mdr",
      name: "generate-mdr",
      component: GenerateMDR,
      beforeEnter: checkAuth
    }, 
    {
      path: "/generate-mdrs1mtm",
      name: "generate-mdrs1mtm",
      component: GenerateMDRS1MtM,
      beforeEnter: checkAuth
    },          
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "*",
      component: () => import(/* webpackChunkName: "about" */ "./views/404.vue")
    }
  ]
});
